import { useState } from "react";
import { useDispatch } from "react-redux";
import { loginAdmin } from "~/redux/modules/admin/auth";
import { Event } from "~/types/component";

export const useModule = () => {
  const dispatch = useDispatch();

  // states
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  // setters
  const changeEmail = (e: Event) => {
    setEmail(e.target.value);
  };
  const changePassword = (e: Event) => {
    setPassword(e.target.value);
  };

  // actions
  const onClickLogin = () => {
    dispatch(loginAdmin({ email, password }));
  };

  return {
    states: { email, password },
    setters: { changeEmail, changePassword },
    actions: { onClickLogin },
  };
};
